import { render, staticRenderFns } from "./ItemTodasMensagens.vue?vue&type=template&id=637e2e1c&scoped=true"
import script from "./ItemTodasMensagens.vue?vue&type=script&lang=js"
export * from "./ItemTodasMensagens.vue?vue&type=script&lang=js"
import style0 from "./ItemTodasMensagens.vue?vue&type=style&index=0&id=637e2e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e2e1c",
  null
  
)

export default component.exports